import React, { useState, useEffect } from "react";

export default function CooldownButton({ onClick, title, disabled }) {
  const [cooling, setCooling] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timer;
    if (cooling) {
      setSeconds(60); // reset counter
      timer = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setCooling(false);
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [cooling]);

  const handleClick = () => {
    if (disabled || cooling) return;
    onClick();
    setCooling(true);
  };

  const styles = {
    button: {
      flex: 1,
      padding: 12,
      marginLeft: 8,
      border: "none",
      borderRadius: 6,
      background: disabled || cooling ? "#ccc" : "#1976d2",
      color: "#fff",
      fontSize: 14,
      fontWeight: 600,
      cursor: disabled || cooling ? "not-allowed" : "pointer",
      transition: "background 0.2s",
    }
  };

  return (
    <button
      style={styles.button}
      onClick={handleClick}
      disabled={disabled || cooling}
    >
      {cooling ? `${title} (${seconds}s)` : title}
    </button>
  );
}




// import React, { useState } from "react";

// export default function CooldownButton({ onClick, title, disabled }) {
//   const [cooling, setCooling] = useState(false);

//   const handleClick = () => {
//     if (disabled || cooling) return;
//     onClick();
//     setCooling(true);
//     setTimeout(() => setCooling(false), 60_000); // 1 minute
//   };

//   const styles = {
//     button: {
//       flex: 1,
//       padding: 12,
//       marginLeft: 8,
//       border: "none",
//       borderRadius: 6,
//       background: disabled || cooling ? "#ccc" : "#1976d2",
//       color: "#fff",
//       fontSize: 14,
//       fontWeight: 600,
//       cursor: disabled || cooling ? "not-allowed" : "pointer",
//       transition: "background 0.2s",
//     }
//   };

//   return (
//     <button
//       style={styles.button}
//       onClick={handleClick}
//       disabled={disabled || cooling}
//     >
//       {cooling ? `${title} (wait)` : title}
//     </button>
//   );
// }




// import React, { useState } from "react";

// export default function CooldownButton({ onClick, title, disabled }) {
//   const [cooldown, setCooldown] = useState(false);

//   const handleClick = () => {
//     if (disabled || cooldown) return;
//     onClick();
//     setCooldown(true);
//     setTimeout(() => setCooldown(false), 60000); // 1 minute
//   };

//   return (
//     <button onClick={handleClick} disabled={disabled || cooldown}>
//       {cooldown ? `${title} (wait)` : title}
//     </button>
//   );
// }
